import React from "react";
import styles from "./usuarios.module.css";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
// import { IPostInsight } from "../../../../interfaces/insightPost";

type Props = {
  selected: string;
};

const Usuarios = ({ selected }: Props) => {
  // const createList = (insight: IPostInsight) => {
  //   return (
  //     <li key={insight.id} className={styles.list_item}>
  //       <span className={`${styles.list_item_title} ${styles.w50}`}>
  //         {insight.title}
  //       </span>
  //       <span className={`${styles.list_item_text} ${styles.w20}`}>
  //         {insight.date}
  //       </span>
  //       <span className={`${styles.list_item_text} ${styles.w20}`}>
  //         {insight.user}
  //       </span>
  //       <div className={`${styles.action_btn_div} ${styles.w5}`}>
  //         <button className={styles.action_btn}>
  //           <FontAwesomeIcon icon={faEdit} size="sm" />
  //         </button>
  //       </div>
  //       <div className={`${styles.action_btn_div} ${styles.w5}`}>
  //         <button className={styles.action_btn}>
  //           <FontAwesomeIcon icon={faTrash} size="sm" />
  //         </button>
  //       </div>
  //     </li>
  //   );
  // };

  React.useEffect(() => {
    // carregar dados do usuário
  }, [selected]);

  return (
    <section className={styles.usuarios}>
      <div className={styles.header}>
        <h4 className={styles.title}>Meus Insights</h4>
        <div className={styles.action_btn_div}>
          <button className={styles.action_btn}>Novo Insight</button>
        </div>
      </div>
      <div className={styles.list_container}>
        <div className={styles.container_title_div}>
          <h1 className={styles.container_title}>Lista de Usuários</h1>
        </div>
        <div className={styles.grid_list}>
          <div className={styles.list_cabecalho}>
            <span className={`${styles.list_cabecalho_title} ${styles.w50}`}>
              Título
            </span>
            <span className={`${styles.list_cabecalho_text} ${styles.w20}`}>
              Data da Postagem
            </span>
            <span className={`${styles.list_cabecalho_text} ${styles.w20}`}>
              Postado pelo Usuário
            </span>
            <span className={`${styles.w5}`}></span>
            <span className={`${styles.w5}`}></span>
          </div>
          <ul className={styles.list}>
            {/* {InsightsPosts.map((insight: IPostInsight) => createList(insight))} */}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Usuarios;
